'use strict';

const $ = require('jquery');
const Breakpoint = require('./../lib/breakpoints');

class Treatments {

    constructor() {

        let $treatmentAccordion = $('.overview-treatments [data-responsive-accordion-tabs]');

        if ($treatmentAccordion.length > 0) {

            if (Breakpoint.atLeast('medium')) {

                $treatmentAccordion.foundation('destroy');

                $treatmentAccordion.find('.accordion-title').on('click', (event) => {

                    event.preventDefault();
                });
            }
        }
    }
}

module.exports = Treatments;
